import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

import {ProcessFlowchartNodeType} from './processFlowchartConfigEditorConstants';

export interface LogicNodeMetadata {
  name: string;
  icon: BenchlingIconName;
}

export const LOGIC_NODE_METADATA: Record<
  ProcessFlowchartNodeType.ROUTER_NODE | ProcessFlowchartNodeType.STOP_NODE,
  LogicNodeMetadata
> = {
  [ProcessFlowchartNodeType.ROUTER_NODE]: {
    name: 'Router',
    icon: 'diamond',
  },
  [ProcessFlowchartNodeType.STOP_NODE]: {
    name: 'Stop',
    icon: 'do-not-enter',
  },
};

export function getLogicNodeMetadata(
  nodeType: ProcessFlowchartNodeType.ROUTER_NODE | ProcessFlowchartNodeType.STOP_NODE
): LogicNodeMetadata {
  return LOGIC_NODE_METADATA[nodeType];
}
